import { render, staticRenderFns } from "./FormInputUnit.vue?vue&type=template&id=5033282c&scoped=true&lang=pug"
import script from "./FormInputUnit.vue?vue&type=script&lang=ts"
export * from "./FormInputUnit.vue?vue&type=script&lang=ts"
import style0 from "./FormInputUnit.vue?vue&type=style&index=0&id=5033282c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5033282c",
  null
  
)

export default component.exports